import { createFileRoute } from "@tanstack/react-router"
import { HeaderedErrorFallback } from "~/components/error"
import { QueryBoundary } from "~/components/query-boundary"
import { Post } from "../features/post/components/post"
import { PostSkeleton } from "../features/post/components/post-skeleton"

export const Route = createFileRoute("/post/$id")({
  component: PostPage,
})

function PostPage() {
  return (
    <div className="flex-1 flex flex-col">
      <QueryBoundary loadingFallback={<PostSkeleton />} errorFallback={HeaderedErrorFallback}>
        <Post />
      </QueryBoundary>
    </div>
  )
}
